<!-- AlertModal.vue -->
<template>
  <b-modal
    v-model="showModal"
    size="md"
    hide-footer
    centered
    :header-bg-variant="headerBgVariant"
    :header-text-variant="headerTextVariant"
    :no-close-on-backdrop="true">
    <template v-slot:modal-header>
      <div>{{ title }}</div>
    </template>
    <template v-slot:default>
      <div>
        <div style="white-space: pre-wrap !important;">
          {{ message }}
        </div>
      </div>
      <div class="mt-3">
        <div class="text-right">
          <b-button size="sm" @click="handleOk" variant="success" class="px-3">OK</b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
/* eslint-disable */
export default {
  props: {
      title: { type: String, default: "" },
      message: { type: String, default: "" },
      headerVariant: { type: String, default: "danger" },
  },
  data: function () {
    return {
      showModal: false,
    };
  },
  computed: {
    headerBgVariant: function () {
      if (this.headerVariant == "danger") {
        return "danger";
      }

      return "";
    },
    headerTextVariant: function () {
      if (this.headerVariant == "danger") {
        return "white";
      }
      return "";
    },
  },
  methods: {
    openModal: function () {
      this.showModal = true;
    },
    handleOk: function () {
      this.showModal = false;
      this.$emit("handleOk");
    },
  },
};
</script>
